var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargingPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.34 9.49602L20.34 8.49602C19.97 8.31602 19.51 8.45602 19.33 8.82602C19.14 9.20602 19.29 9.65602 19.66 9.83602L21.25 10.626V15.416L17.5 15.426V5.16602C17.5 3.16602 16.16 2.16602 14.5 2.16602H6.5C4.84 2.16602 3.5 3.16602 3.5 5.16602V21.416H2C1.59 21.416 1.25 21.756 1.25 22.166C1.25 22.576 1.59 22.916 2 22.916H19C19.41 22.916 19.75 22.576 19.75 22.166C19.75 21.756 19.41 21.416 19 21.416H17.5V16.926L22 16.916C22.42 16.916 22.75 16.576 22.75 16.166V10.166C22.75 9.88602 22.59 9.62602 22.34 9.49602ZM6 7.05602C6 5.66602 6.85 5.16602 7.89 5.16602H13.12C14.15 5.16602 15 5.66602 15 7.05602V8.28602C15 9.66602 14.15 10.166 13.11 10.166H7.89C6.85 10.166 6 9.66602 6 8.27602V7.05602ZM6.5 12.416H9.5C9.91 12.416 10.25 12.756 10.25 13.166C10.25 13.576 9.91 13.916 9.5 13.916H6.5C6.09 13.916 5.75 13.576 5.75 13.166C5.75 12.756 6.09 12.416 6.5 12.416Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingPoint);
export default __webpack_public_path__ + "static/media/charging-point.86c92b851fef8583afe0d6378f5838d3.svg";
export { ForwardRef as ReactComponent };